export const CONTACT = {
  phone: "(850) 687 7606",
  phoneHref: "tel:+18506877606",
  email: "christianregalado@gmail.com",
  serviceAreas: ["Santa Rosa Beach", "Miramar Beach", "Destin", "Panama City Beach"],
};

export const HEROES = {
  home: "https://images.pexels.com/photos/27890859/pexels-photo-27890859.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  corporate: "/wedding-hero.jpg",
  beach: "https://images.unsplash.com/photo-1652945374241-8961cae72d0b?auto=format&fit=crop&w=1600&q=80",
  avGearList: "/av-gear-hero.jpg",
  corporateEvents: "/corporate-events-hero.jpg",
};

export const EVENT_PACKAGES = [
  {
    name: "Complete Breakout Package",
    featured: true,
    priceFirst: "$1,200",
    priceAdd: "$400 / each additional day",
    blurb: "Our full video + audio breakout room solution — everything you need for a polished corporate session, delivered, set up and torn down for you.",
    groups: [
      {
        label: "Video",
        items: [
          "(1) Da-Lite 6' x 10' projector screen with dress kit",
          "(1) Epson 4K laser projector — or choose (2) 65\" 4K TVs with stands",
        ],
      },
      {
        label: "Audio",
        items: [
          "(2) QSC K10 speakers",
          "(1) 8-channel digital console",
          "(1) Gooseneck podium microphone",
          "(2) Shure wireless microphones (handheld or lavalier)",
        ],
      },
    ],
    includes: "All necessary power and data cables.",
    addon: "Add an in-room operator to run all equipment — $600 / day (up to 10 hrs).",
  },
  {
    name: "Audio Package",
    priceFirst: "$750",
    priceAdd: "$300 / each additional day",
    blurb: "Crystal-clear sound for speeches, panels and presentations.",
    groups: [
      {
        label: "Audio",
        items: [
          "(2) QSC K10 speakers with stands",
          "(1) 8-channel digital audio console",
          "(2) Shure wireless microphones (handheld or lavalier)",
        ],
      },
    ],
    includes: "Includes all connecting power and data cables.",
  },
  {
    name: "Video Package",
    priceFirst: "$750",
    priceAdd: "$250 / each additional day",
    blurb: "Big, bright visuals for slides, video and branded content.",
    groups: [
      {
        label: "Video",
        items: [
          "(1) Da-Lite 6' x 10' projector screen with dress kit",
          "(1) Epson 4K laser projector",
          "or (2) 65\" Sony 4K TVs with stands and necessary power & data cables",
        ],
      },
    ],
  },
];

export const CATEGORY_IMAGES = {
  corporate: "/home-corporate.jpg",
  beach: "https://images.pexels.com/photos/17376721/pexels-photo-17376721.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const WEDDING_AV_PACKAGE = {
  name: "Complete Wedding Audio/Video Package",
  price: "$1,000",
  image: "/wedding-av-package.jpg",
  fit: "contain",
  blurb: "Everything you need for a flawless ceremony and reception — clear sound for vows and toasts plus a beautiful 4K display, delivered and set up for you.",
  items: [
    "(2) QSC K10 speakers",
    "(1) Podium microphone",
    "(2) Shure wireless microphones (handheld or lavalier)",
    "(1) 8-channel digital console",
    "(1) 65\" Sony 4K TV with stand",
    "All necessary power and audio cables",
  ],
  addon: "Add an AV operator — $400 (up to 5 hrs) or $600 (up to 10 hrs).",
};

export const WEDDING_AUDIO_LIGHTS_PACKAGE = {
  name: "Complete Audio & String Lights Package",
  price: "$1,200",
  image: "/beach-audio-string-lights.jpg",
  fit: "contain",
  blurb: "Set the scene for a magical beachfront ceremony or reception — warm string-light ambiance plus crystal-clear sound, powered anywhere off-grid.",
  items: [
    "(6) strands of string lights with mounting poles and bases",
    "(2) QSC K10 speakers",
    "(1) 8-channel audio mixer",
    "(1) Shure wireless handheld microphone",
    "(1) 3,000-watt portable power bank for off-grid power (2–4 hours of power for all gear)",
  ],
};

export const CORPORATE_GEAR = [
  {
    name: "Powered Speakers",
    image: "/powered-speakers.jpg",
    fit: "contain",
    desc: "Full-range powered speakers and line arrays that deliver crisp, room-filling sound for any size venue.",
    tags: ["Indoor & outdoor", "Stands included"],
  },
  {
    name: "Projectors",
    image: "https://images.unsplash.com/photo-1535016120720-40c646be5580?auto=format&fit=crop&w=940&q=80",
    desc: "Bright HD & 4K projectors perfect for presentations, slideshows, and wedding photo montages.",
    tags: ["HD / 4K", "HDMI ready"],
  },
  {
    name: "Projection Screens",
    image: "https://images.unsplash.com/photo-1540317580384-e5d43616b9aa?auto=format&fit=crop&w=940&q=80",
    desc: "Large-format projection screens sized for ballrooms, conferences, and outdoor ceremonies.",
    tags: ["Multiple sizes", "Fast frame"],
  },
  {
    name: "Audio Mixers",
    image: "https://images.pexels.com/photos/33204438/pexels-photo-33204438.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "Digital and analog mixing consoles to balance music, speeches, and live performances flawlessly.",
    tags: ["Digital & analog", "Tech support"],
  },
  {
    name: "Microphones",
    image: "https://images.pexels.com/photos/12997263/pexels-photo-12997263.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "Wireless handheld, lavalier, and podium mics so every toast and announcement is heard clearly.",
    tags: ["Wireless", "Lav & handheld"],
  },
];

export const BEACH_GEAR = [  {
    name: "Beach Chairs",
    image: "https://images.pexels.com/photos/17376721/pexels-photo-17376721.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "Comfortable, sturdy beach chairs delivered and set up right on the sand for your group.",
    tags: ["Single & sets", "Delivered"],
  },
  {
    name: "Sun Umbrellas",
    image: "https://images.unsplash.com/photo-1521170813716-0b3f42fcfb65?auto=format&fit=crop&w=940&q=80",
    desc: "Large UV-rated umbrellas anchored securely to keep your party cool and shaded all day.",
    tags: ["UV protection", "Wind-anchored"],
  },
  {
    name: "String Lights",
    image: "https://images.pexels.com/photos/17241518/pexels-photo-17241518.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "Warm bistro string lights to give beach dinners, receptions, and bonfires a magical glow.",
    tags: ["Ambient glow", "Setup included"],
  },
  {
    name: "Firepits",
    image: "https://images.pexels.com/photos/10906955/pexels-photo-10906955.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "Portable beach firepits for cozy evenings under the stars — permit-friendly and safe.",
    tags: ["Portable", "Wood ready"],
  },
  {
    name: "Power Stations",
    image: "https://images.pexels.com/photos/37489594/pexels-photo-37489594.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "Quiet electric battery generators to power lights, speakers, and devices anywhere on the beach.",
    tags: ["Silent", "High capacity"],
  },
];

export const AV_GEAR_LIST = [
  {
    name: "Epson 5K Projector",
    image: "https://images.unsplash.com/photo-1535016120720-40c646be5580?auto=format&fit=crop&w=940&q=80",
    desc: "Ultra-bright 5,000-lumen Epson projector delivering crisp, vivid imagery for large rooms, daylight venues, and outdoor screenings.",
    tags: ["5,000 lumens", "HD / 4K enhanced"],
  },
  {
    name: "Da-Lite 6' x 9' Fast-Fold Screen w/ Dress Kit",
    image: "https://images.pexels.com/photos/12111225/pexels-photo-12111225.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "Professional 6' x 9' Da-Lite Fast-Fold projection screen with full dress kit for a clean, finished look at any event.",
    tags: ["6' x 9'", "Dress kit included"],
  },
  {
    name: "QSC TouchMix-8 Digital Mixer",
    image: "/qsc-touchmix-8.jpg",
    fit: "contain",
    desc: "Compact QSC TouchMix-8 digital mixer with 8 inputs, touchscreen control, onboard effects and wireless mixing — ideal for smaller events.",
    tags: ["8-channel", "Touchscreen"],
  },
  {
    name: "QSC TouchMix-16 Digital Mixer",
    image: "/qsc-touchmix-16.jpg",
    fit: "contain",
    desc: "QSC TouchMix-16 digital mixer with 16 inputs, touchscreen control and full recording capability for larger, multi-source productions.",
    tags: ["16-channel", "Touchscreen"],
  },
  {
    name: "Mackie 1202 Mixer",
    image: "/mackie-1202.jpg",
    fit: "contain",
    desc: "Reliable Mackie 1202 analog mixer — the go-to for speeches, panels, and small-format audio setups.",
    tags: ["12-channel", "Analog"],
  },
  {
    name: "Shure Wireless Microphones",
    image: "https://images.pexels.com/photos/12997263/pexels-photo-12997263.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "Shure wireless microphone systems available in handheld and lavalier (lapel) styles for clear, dependable audio.",
    tags: ["Handheld", "Lavalier"],
  },
  {
    name: "QSC K10 Speaker & Stand",
    image: "/qsc-k10.jpg",
    fit: "contain",
    desc: "Powered QSC K10 10\" speaker on a tripod stand — punchy, articulate sound perfect for mid-size gatherings.",
    tags: ["10\" powered", "Stand included"],
  },
  {
    name: "QSC K12 Speaker & Stand",
    image: "/qsc-k12.jpg",
    fit: "contain",
    desc: "Powered QSC K12 12\" speaker on a tripod stand — room-filling output for larger rooms and outdoor events.",
    tags: ["12\" powered", "Stand included"],
  },
  {
    name: "65\" LG LCD TV Monitor & Stand",
    image: "/tv-rental.jpg",
    fit: "contain",
    desc: "65-inch LG LCD monitor on a rolling floor stand — ideal for slideshows, signage, and presentations.",
    tags: ["65-inch", "Floor stand"],
  },
  {
    name: "LG 4K TV Monitor & Stand",
    image: "/tv-rental.jpg",
    fit: "contain",
    desc: "Crystal-clear LG 4K monitor with floor stand for stunning video playback, menus, and branded displays.",
    tags: ["4K UHD", "Floor stand"],
  },
  {
    name: "String Lights",
    image: "https://images.pexels.com/photos/17241518/pexels-photo-17241518.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "Warm bistro string lights that add a magical ambient glow to receptions, dinners, and lounges.",
    tags: ["Ambient glow", "Setup included"],
  },
  {
    name: "Off-Grid Electric Power Supply",
    image: "https://images.pexels.com/photos/37489594/pexels-photo-37489594.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "Silent electric battery power supply to run AV gear and lighting anywhere — no generator noise, no outlets required.",
    tags: ["Silent", "Off-grid ready"],
  },
];
